import { Component, OnInit, Input, OnChanges, EventEmitter, Output, ChangeDetectorRef, ElementRef, Renderer2 } from '@angular/core';
import { LocaleService } from '@app/system/services/locale.service';
import { ApiService } from './utilities/services/api.service';
import { PopupComponent } from '@app/components/popup/popup.component';
import { ConversationUpdateComponent } from './conversation-update/conversation-update.component';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { BaseService } from '@app/system/services/base.service';
import { UntypedFormGroup } from '@angular/forms';
import { HandleBarPipe } from '@app/system/pipes/handle-bar/handle-bar.pipe';
import { GlobalFunctionService } from '@app/system/services/global-function.service';
import { QuillEditorModel } from '@app/components/controls/utilities/models/quill-editor-model';
import { ResourceFormsComponent } from '../resource/resource-forms/resource-forms.component';
import { DetectDeviceService } from '@app/system/services/detect-device.service';

@Component({
	selector: 'app-conversation',
	templateUrl: './conversation.component.html',
	styleUrls: ['./conversation.component.scss']
})
export class ConversationComponent implements OnInit, OnChanges {

	// @Input() status: 'show' | 'hide' | 'inactive' = 'show';
	// @Input() type: 'answer' | 'conversation' = 'conversation';
	// @Input() resourceDetail;
	@Input() data;
	@Output() recordCount = new EventEmitter<number>();
	@Output() reloadResource = new EventEmitter();

	formFields: any = [];
	config = { fxFlex: 100 };
	formObject;
	loader = false;
	list = [];
	submitDisable = true;
	conversationCount = 0;
	count = 1;
	title;
	index;
	currentUser;
	limit = 5;
	bestAnswer: boolean = false;
	userThumbnail = 'assets/img/man.png';
	deviceDetails;

	constructor(
		public locale: LocaleService,
		private handleBarPipe: HandleBarPipe,
		private baseService: BaseService,
		public gfService: GlobalFunctionService,
		private apiService: ApiService,
		private popup: MatDialog,
		public detectDevice: DetectDeviceService,
		private cdref: ChangeDetectorRef,
		private elementRef: ElementRef,
		private renderer2: Renderer2
	) {
		this.currentUser = this.gfService.sessionUser;
		if (this.currentUser && this.currentUser.profile && this.currentUser.profile.profilePicURL) {
			this.userThumbnail = this.currentUser.profile.profilePicURL;
		}
	}

	ngOnInit(): void {
		this.deviceDetails = this.detectDevice.fingerPrint;
	}

	ngOnChanges(changes) {
		if (changes.data && changes.data.currentValue && changes.data.currentValue.resourceData && this.list.length === 0) {
			const resourceData = changes.data.currentValue.resourceData;
			if (resourceData.settings && (resourceData.settings.commenting === 'show' || resourceData.settings.commenting === 'inactive')) {
				this.loader = true;
				this.getList();
				if (resourceData.settings.commenting === 'show') {
					this.formFields = this.getFields();
				}
			}
		}
	}

	searchPeopleDetail(data) {
		if (data && data.userID) {
			this.baseService.userDetail(data.userID);
		}
	}

	collapsibleToggle(event: any) {
		if (event && !this.list.length) {
			this.loader = true;
			this.getList();
		}
	}

	getList(pageNumber: number = 1) {
		const headers = {};
		const params = {
			limit: this.limit,
			pageNumber,
			resourceID: this.data.resourceData.resourceID
		};
		let method = this.apiService.getConversationList(params, headers);
		if (this.data.resourceData && this.data.resourceData.resourceTypeID && this.data.resourceData.resourceTypeID.key === 'answer') {
			method = this.apiService.getAnswerList(params, headers);
		}
		method.subscribe(
			(response) => {
				if (response && response.hasOwnProperty('records')) {
					this.conversationCount = response.totalRecordCount;
					this.dataBuild('conversationList', response.records)
				}
			},
			(error) => {
				this.gfService.errorHandler(error, {
					snackBar: {
						position: 'before'
					}
				});
			}
		)
			.add(() => {
				this.loader = false;
				let title = this.locale.translate('conversation');
				if (this.data.resourceData && this.data.resourceData.resourceTypeID && this.data.resourceData.resourceTypeID.key === 'answer') {
					title = this.locale.translate('answers_count');
				}
				this.title = this.handleBarPipe.transform(title, {
					count: this.conversationCount
				});
			});
	}

	getFields() {
		// const message: TextAreaModel = {
		// 	fieldColumn: 'message',
		// 	additionalMetaData: {
		// 		maxChar: 500,
		// 		fieldConfig: {
		// 			appearance: 'standard',
		// 			floatLabel: 'auto'
		// 		},
		// 		minRows: 1,
		// 		maxRows: 15
		// 	},
		// 	fieldType: 'textArea',
		// 	isHidden: false,
		// 	isReadonly: false,
		// 	fieldHelpText: '', // this.locale.translate('post_content_helptext'),
		// 	validationRegex: null,
		// 	isRequired: false,
		// 	fieldCaption: (this.data.type === 'conversation') ? this.locale.translate('say_something') : this.locale.translate('your_answer'),
		// 	fieldOrder: 1,
		// 	fieldPlaceholder: (this.data.type === 'conversation') ? this.locale.translate('say_something') : this.locale.translate('your_answer')
		// };
		const message: QuillEditorModel = {
			fieldCaption: (this.data.resourceData && this.data.resourceData.resourceTypeID && this.data.resourceData.resourceTypeID.key === 'conversation') ? this.locale.translate('say_something') : this.locale.translate('your_answer'),
			fieldColumn: 'message',
			validationRegex: '',
			validationMessage: '',
			fieldOrder: 1,
			fieldType: 'quillEditor',
			fieldHelpText: '',
			isRequired: false,
			isHidden: false,
			additionalMetaData: {
				// height: 400,
				showLabel: false,
				imageUploadData: {
					fileSize: '10MB',
					supportedType: ['.jpg', '.jpeg', '.png', '.gif'],
					url: ''
				},
				config: {
					toolbar: [
						['link', 'image', 'video', 'formula', 'code-block'],
						// ['emoji'],
					],
					// toolbar: '#toolbar-container',
					// 'emoji-toolbar': true,
					// 'emoji-textarea': true,
					// 'emoji-shortname': true,
					formula: true,
					imageResize: true
				}
			},
			isReadonly: false,
			value: null,
			fieldPlaceholder: (this.data.resourceData && this.data.resourceData.resourceTypeID && this.data.resourceData.resourceTypeID.key !== 'answer') ? this.locale.translate('say_something') : this.locale.translate('your_answer')
		};
		return [message];
	}

	dataBuild(action: string, records: any) {
		for (const data of records) {
			const cardData: any = {
				message: data.message,
				date: this.baseService.processTime(data.createdAt),
				recordID: data.messageID,
				showEditor: false,
				formObject: null,
				config: this.config,
				disable: false,
				showMenu: false,
				formFields: []
			};
			if (data.author) {
				cardData.imageSrc = data.author.profilePicURL;
				cardData.title = `${data.author.firstName}${data.author.lastName
					? ' ' + data.author.lastName
					: ''}`;
				if (data.author.userID === this.currentUser.userID) {
					data.showMenu = true;
				}
			}
			data.showMenu = this.baseService.checkAccessControl('RES005');

			// if (data.thumbsUpCount === 0) {
			// 	delete data.thumbsUpCount;
			// }
			// if (data.thumbsDownCount === 0) {
			// 	delete data.thumbsDownCount;
			// }
			data.status = this.baseService.referenceType('conversationStatus', data.status)
			if (action === 'conversationList') {
				if (this.data.resourceData && this.data.resourceData.infoFields && this.data.resourceData.infoFields.bestAnswer) {
					if (Array.isArray(this.data.resourceData.infoFields.bestAnswer)) {
						if (this.data.resourceData.infoFields.bestAnswer.includes(data.messageID)) {
							this.bestAnswer = true;
						}
					}
				}
				this.list.push(this.gfService.JSONMerge(cardData, data));
			} else {
				this.list.unshift(this.gfService.JSONMerge(cardData, data));
				this.conversationCount += 1;
				this.recordCount.emit(this.conversationCount);
				let title = this.locale.translate('conversation');
				if (this.data.resourceData && this.data.resourceData.resourceTypeID && this.data.resourceData.resourceTypeID.key === 'answer') {
					title = this.locale.translate('answers_count');
				}
				this.title = this.handleBarPipe.transform(title, {
					count: this.conversationCount
				});
			}
		}
	}

	updateLike(type: string, data: any) {
		if (navigator.onLine) {
			if (this.data.resourceData && this.data.resourceData.settings && this.data.resourceData.settings.commenting !== 'inactive') {
				if (!data.disable) {
					data.disable = true;
					const headers: any = {};
					let apiMethod;
					if (this.data.resourceData && this.data.resourceData.resourceTypeID && this.data.resourceData.resourceTypeID.key !== 'answer') {
						if (data.liked === 0) {
							apiMethod = this.apiService.conversationLike(data.messageID, headers);
						} else {
							apiMethod = this.apiService.conversationUnLike(data.messageID, headers);
						}
					} else {
						if (data.liked === 0) {
							apiMethod = this.apiService.answerLike(data.messageID, headers);
						} else {
							apiMethod = this.apiService.answerUnLike(data.messageID, headers);
						}
					}
					apiMethod
						.subscribe(
							(response) => {
								if (data.liked === 0) {
									this.baseService.logUserActivity('like', 'engagement', [''], { resourceData: this.data.resourceData });
									data.thumbsUpCount += 1;
									data.liked = 1;
								} else {
									this.baseService.logUserActivity('unlike', 'engagement', [''], { resourceData: this.data.resourceData });
									data.thumbsUpCount -= 1;
									data.liked = 0;
								}
							},
							(error) => {
								if (error.error.hasOwnProperty('errorCode') && error.error.errorCode === "DUPLICATE") {
									const errorMsg = (this.data.resourceData.resourceTypeID.key === 'answer') ? 'answer_already_liked' : 'conversation_already_liked';
									error.error = this.locale.translate(errorMsg);
									this.reloadResource.emit(true);
								}
								this.gfService.openSnackBar('ERROR', {
									message: error.error.message,
									icon: 'error',
									position: 'before'
								});
							})
						.add(() => {
							data.disable = false;
						});
				}
			}
		}
	}

	loadResource(action: string, data: any, additionalData: any = {}) {
		if (navigator.onLine) {
			if (action === 'rejectConversation') {
				const dialogRef = this.popup.open(PopupComponent, {
					panelClass: ['custom-panel'],
					data: {
						action: 'dynamic',
						popup: true,
						component: ConversationUpdateComponent,
						componentData: [
							{
								variableName: 'action',
								value: action
							},
							{
								variableName: 'conversationData',
								value: data
							},
						]
					},
					disableClose: true,
					maxWidth: '860px'
				});
				dialogRef.afterClosed().subscribe(async (result) => {
					if (result && typeof result === 'object') {
					}
				});
			} else if (action === 'editConversation') {
				data.showEditor = true;
				data.formFields = this.getFields();
				data.formFields[0].value = data.message;
			} else if (action === 'deleteConversation') {
				const dialogRef = this.popup.open(PopupComponent, {
					panelClass: ['custom-panel'],
					autoFocus: false,
					data: {
						action: 'alert',
						classes: 'warning',
						popup: true,
						icon: 'warning',
						title: this.locale.translate('delete_conversation'),
						content: this.locale.translate('delete_conversation_info'),
						buttons: [
							{
								type: 'main-action',
								caption: this.locale.translate('yes'),
								key: 'yes'
							},
							{
								type: 'main-action',
								caption: this.locale.translate('no'),
								key: 'no',
								autoFocus: true
							}
						],
						// triggerEl: additionalData.actionElement
					},
					disableClose: true,
					maxWidth: '560px'
				});
				dialogRef.afterClosed().subscribe((resp) => {
					if (resp) {
						if (action === 'deleteConversation') {
							if (resp.key === 'yes') {
								this.deleteConversation(data, additionalData.index);
							}
						}
					}
				});
			}
		}
	}

	guideline() {
		if (navigator.onLine) {
			const dialogRef = this.popup.open(PopupComponent, {
				panelClass: ['custom-panel'],
				data: {
					action: 'dynamic',
					popup: true,
					component: ResourceFormsComponent,
					componentData: [
						{
							variableName: 'action',
							value: 'guideline'
						}
					]
				},
				disableClose: true,
				maxWidth: '600px'
			});
			dialogRef.afterClosed().subscribe(async (result) => {
				if (result) {
				}
			});
		}
	}

	submit(action: string, data: any = null) {
		if (navigator.onLine) {
			if (action === 'addConversation') {
				this.saveConversation(data);
			} else if (action === 'updateConversation') {
				this.updateConversation(data);
			} else if (action === 'updateAnswer') {
				this.updateAnswer(data)
			}
		}
	}

	saveConversation(data) {
		const headers: any = {};
		if (this.formObject && this.formObject.form) {
			// this.submitDisable = true;
			this.gfService.alertClear('conversationAlert');
			if (this.formObject.form.valid) {
				this.loader = true;
				const data: any = this.gfService.fieldSubmitApiValueConstruct(
					this.formObject.form.getRawValue(),
					this.formObject.fields
				);
				const apiValue = this.gfService.JSONMerge(data, { resourceID: Number(this.data.resourceData.resourceID) });
				let method = this.apiService.addConversation(apiValue, headers);
				let eventName = 'postconversation';
				let eventType = 'engagement';
				if (this.data.resourceData && this.data.resourceData.resourceTypeID && this.data.resourceData.resourceTypeID.key === 'answer') {
					eventName = 'postanswer';
					eventType = 'sharing';
					method = this.apiService.addAnswer(apiValue, headers);
				}
				apiValue.notificationType = 1;
				if (this.deviceDetails.browserName === 'Safari') {
					apiValue.notificationType = 2;
				}
				method.subscribe(
					(response) => {
						let status = false;
						if (this.data.resourceData && this.data.resourceData.authors && this.data.resourceData.authors.length) {
							if (this.data.resourceData.authors.find(items => items.userID === this.currentUser.userID)) {
								status = true;
							}
						}
						if (!status) {
							this.baseService.logUserActivity(eventName, eventType, [''], { resourceData: this.data.resourceData });
						}
						// this.submitDisable = true;
						this.gfService.openSnackBar('SUCCESS', {
							message: this.locale.translate('message_posted'),
							icon: 'check_circle_outline',
							position: 'before'
						});
						apiValue.author = {
							profilePicURL: this.currentUser.profile.profilePicURL,
							firstName: this.currentUser.profile.firstName,
							lastName: this.currentUser.profile.lastName,
							userID: this.currentUser.userID
						};
						apiValue.createdAt = new Date().getTime();
						apiValue.recordID = response.recordID;
						apiValue.messageID = response.recordID;
						apiValue.thumbsUpCount = 0;
						apiValue.liked = 0;
						apiValue.isLiked = false;

						const conversationStatus = this.baseService.conversationStatus;
						for (const status of conversationStatus) {
							if (status.key === 'published') {
								apiValue.status = status.value;
							}
						}

						const form: UntypedFormGroup = this.formObject.form;
						form.controls.message.patchValue('');
						form.controls.message.setErrors(null);
						form.controls.message.markAsUntouched();
						this.submitDisable = false;
						this.submitDisable = true;
						this.dataBuild('addConversation', [this.gfService.JSONMerge(apiValue, response)]);
					},
					(error) => {
						this.submitDisable = false;
						this.gfService.errorHandler(error, {
							alert: {
								id: 'conversationAlert'
							}
						});
					}
				)
					.add(() => {
						this.loader = false;
					});
			} else {
				this.submitDisable = false;
				this.gfService.fieldControlMarkAsTouched(this.formObject.fields, this.formObject.form);
			}
		}
	}

	updateConversation(data) {
		const headers: any = {};
		if (data.formObject && data.formObject.form) {
			data.disable = true;
			if (data.formObject.form.valid) {
				const apiValue: any = this.gfService.fieldSubmitApiValueConstruct(
					data.formObject.form.getRawValue(),
					data.formObject.fields
				);
				let method = this.apiService.updatePost(apiValue, data.recordID, headers);
				let eventName = 'comment';
				let trigger = 'comment Update';
				if (this.data.resourceData && this.data.resourceData.resourceTypeID && this.data.resourceData.resourceTypeID.key === 'answer') {
					eventName = 'Answer question';
					trigger = 'Answer question Update';
					method = this.apiService.updateAnswerPost(apiValue, data.recordID, headers);
				}
				method.subscribe(
					(response) => {
						// this.baseService.logUserActivity(eventName, [trigger]);
						data.message = apiValue.message;
						data.showEditor = false;
						this.gfService.openSnackBar('SUCCESS', {
							message: this.locale.translate('message_updated'),
							icon: 'check_circle_outline',
							position: 'before'
						});
					},
					(error) => {
						this.gfService.errorHandler(error, {
							snackBar: {
								position: 'before'
							},
							form: data.formObject.form
						});
					})
					.add(() => {
						data.disable = false;
					});
			} else {
				this.gfService.fieldControlMarkAsTouched(data.formObject.fields, data.formObject.form);
				data.disable = false;
			}
		}
	}

	updateAnswer(data) {
		const headers: any = {};
		if (!data.disable) {
			data.disable = true;
			const apiValue = {
				notificationType: 1
			};
			if (this.deviceDetails.browserName === 'Safari') {
				apiValue.notificationType = 2;
			}
			this.apiService
				.updateAnswer(apiValue, this.data.resourceData.resourceID, data.messageID, headers)
				.subscribe(
					(response) => {
						// if (this.data.resourceData.infoFields.bestAnswer) {
						this.bestAnswer = true;
						if (Array.isArray(this.data.resourceData.infoFields.bestAnswer)) {
							this.data.resourceData.infoFields.bestAnswer.push(data.messageID);
						} else {
							this.data.resourceData.infoFields.bestAnswer = [data.messageID];
						}
						// }
						this.gfService.openSnackBar('SUCCESS', {
							message: this.locale.translate('marked_as_asker_choice'),
							icon: 'check_circle_outline',
							position: 'before'
						});
					},
					(error) => {
						if (error.error.hasOwnProperty('errorCode') && error.error.errorCode === "DUPLICATE") {
							error.error = this.locale.translate('answer_already_marked_as_askers_choice');
							this.reloadResource.emit(true);
						}
						this.gfService.errorHandler(error, {
							snackBar: {
								position: 'before'
							}
						});
					})
				.add(() => {
					data.disable = false;
				});
		}
	}

	deleteConversation(data, index: number) {
		const headers: any = {};
		data.disable = true;
		let method = this.apiService.deleteConversation(data.messageID, headers);
		let eventName = 'Comment';
		let trigger = 'Comment Delete';
		if (this.data.resourceData && this.data.resourceData.resourceTypeID && this.data.resourceData.resourceTypeID.key === 'answer') {
			eventName = 'Answer question';
			trigger = 'Answer question Delete';
			method = this.apiService.deleteAnswer(data.messageID, headers);
		}
		method.subscribe(
			(response) => {
				// this.baseService.logUserActivity(eventName, [trigger]);
				this.list.splice(index, 1);
				this.conversationCount -= 1;
				this.recordCount.emit(this.conversationCount);
				let title = this.locale.translate('conversation');
				if (this.data.resourceData && this.data.resourceData.resourceTypeID && this.data.resourceData.resourceTypeID.key === 'answer') {
					title = this.locale.translate('answers_count');
				}
				this.title = this.handleBarPipe.transform(title, {
					count: this.conversationCount
				});
				this.gfService.openSnackBar('SUCCESS', {
					message: this.locale.translate('message_deleted'),
					icon: 'check_circle_outline',
					position: 'before'
				});
			},
			(error) => {
				this.gfService.errorHandler(error, {
					snackBar: {
						position: 'before'
					}
				});
				data.disable = false;
			})
			.add(() => {
			});
	}

	cancel(data) {
		data.showEditor = false;
	}

	formObjectReader(record: any) {
		this.formObject = record;
		const form: UntypedFormGroup = this.formObject.form;
		const quillStyleEl = this.renderer2.createElement('style');
		quillStyleEl.innerHTML = `.ql-editor:after {background: url(${(this.userThumbnail) ? this.userThumbnail : '/assets/img/man.png'}) no-repeat center;}`;
		form.controls.message.valueChanges.subscribe(resp => {
			const quillContainer = this.elementRef.nativeElement.querySelector('.ql-container');
			const quillContainerStyleEl = quillContainer.querySelector('style');
			if ([null, undefined, ''].includes(quillContainerStyleEl)) {
				this.renderer2.appendChild(quillContainer, quillStyleEl);
			}
			if ([null, undefined, ''].includes(resp)) {
				this.submitDisable = true;
			} else {
				this.submitDisable = false;
			}
		});

	}

	conversationObjectReader(record: any, data: any) {
		data.formObject = record;
		const form: UntypedFormGroup = record.form;
		form.controls.message.valueChanges.subscribe(resp => {
			if ([null, undefined, ''].includes(resp)) {
				data.buttonDisable = true;
			} else {
				data.buttonDisable = false;
			}
		});
	}

}
